import SignInForm from '@/components/sign-in/sign-in-form'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import {
  TextureCardContent,
  TextureCardDescription,
  TextureCardFooter,
  TextureCardHeader,
  TextureCardStyled,
  TextureCardTitle,
  TextureSeparator
} from '@/components/ui/texture-card'
import { ThemeToggle } from '@/components/ui/theme'
import AppIcon from '@/images/app-icon.png?url'
import { setToken } from '@/lib/auth'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute, redirect, useRouter } from '@tanstack/react-router'
import { useServerFn } from '@tanstack/react-start'
import { toast } from 'sonner'

export const Route = createFileRoute('/sign-in')({
  component: RouteComponent,
  beforeLoad: ({ context: { user } }) => {
    if (user) {
      throw redirect({ to: '/dashboard' })
    }
  }
})

function RouteComponent() {
  const { orpc, queryClient } = Route.useRouteContext()
  const router = useRouter()
  const setTokenFn = useServerFn(setToken)

  const signInMutationKey = orpc.backoffice.auth.signIn.mutationKey()
  const signIn = useMutation(
    orpc.backoffice.auth.signIn.mutationOptions({
      mutationKey: signInMutationKey,
      onSuccess: async (data) => {
        await setTokenFn({ data: { token: data.token } })
        localStorage.setItem('__auth_token', data.token)

        queryClient.invalidateQueries({
          queryKey: orpc.backoffice.auth.getCurrentUser.queryKey()
        })

        toast.success(`Autentikasi berhasil! Masuk sebagai ${data.user.email}.`)

        router.invalidate()
        router.navigate({ to: '/dashboard' })
      },
      onError: (error) => {
        toast.error(error.message)
      }
    })
  )

  return (
    <div className="flex h-dvh w-full flex-col overflow-x-hidden px-8">
      <div className="flex flex-1 flex-col items-center justify-center">
        <TextureCardStyled className="w-full max-w-96">
          <TextureCardHeader className="flex flex-col items-center justify-center gap-4">
            <img src={AppIcon} alt="App Icon" className="size-14" />
            <div className="flex flex-col items-center justify-center gap-2">
              <TextureCardTitle>Masuk</TextureCardTitle>
              <TextureCardDescription className="mb-4 text-center">
                Selamat datang di Backoffice Desa Wisata! <br /> Silakan masuk
                untuk melanjutkan.
              </TextureCardDescription>
            </div>
          </TextureCardHeader>
          <TextureSeparator />
          <TextureCardContent className="w-full">
            <SignInForm
              onSubmit={signIn.mutate}
              mutationKey={signInMutationKey}
            />
          </TextureCardContent>
          <TextureSeparator />
          <TextureCardFooter className="rounded-b-sm">
            <Button
              className="w-full"
              type="submit"
              form="sign-in-form"
              disabled={signIn.isPending}
            >
              {signIn.isPending ? <Spinner variant="circle" /> : 'Masuk'}
            </Button>
          </TextureCardFooter>
        </TextureCardStyled>
      </div>
      <footer className="flex items-center justify-center py-6">
        <div className="flex items-center justify-center gap-2">
          <ThemeToggle />
        </div>
      </footer>
    </div>
  )
}
